import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=40de22bb&scoped=true&"
import script from "./Editor.vue?vue&type=script&lang=js&"
export * from "./Editor.vue?vue&type=script&lang=js&"
import style0 from "./Editor.vue?vue&type=style&index=0&id=40de22bb&prod&lang=scss&scoped=true&"
import style1 from "./Editor.vue?vue&type=style&index=1&id=40de22bb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40de22bb",
  null
  
)

export default component.exports